module.exports = __webpack_public_path__ + "static/media/food-at-turn.89c1fff2.svg";